import React from 'react';
import {Navigate} from 'react-router-dom';

/**
 * 인증된 사용자만 접근 가능한 라우트 래퍼
 * localStorage 또는 sessionStorage에 userInfo가 없으면 로그인 페이지로 리다이렉트
 */
const ProtectedRoute = ({children}: {children: React.ReactNode}) => {
  const userInfoLocal = localStorage.getItem('userInfo');
  const userInfoSession = sessionStorage.getItem('userInfo');

  if (!userInfoLocal && !userInfoSession) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
